import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthLocalStorage } from '../../modules/useLocalStore';
import stylez from './header.module.css';
import logo from '../../img/logo.png';
import login_img from '../../img/login.svg';
import notice from '../../img/notice.svg';
import bottom_menu from '../../img/bottom.svg';
import top_menu from '../../img/top.svg';

function Header({stage , setStage, page , setPage,myProfile,setMyProfile, setLike, like, setMutual,mutual }){
    const { getToken, removeToken } = useAuthLocalStorage();
    const [items, setItems] = useState([]);
    const token = getToken();
     useEffect(() => {
        if(stage === 0)
        {
            switch(page)
            {
                case 1:
                    setItems([
                        { id: 0, name: "создать аккаунт", img: false }
                    ]);
                return;
                case 2:
                    setItems([
                        { id: 0, name: "создать аккаунт", img: false }
                    ]);
                return;
                default:
                    setItems([
                        { id: 1, name: "Войти", img: true, srcimg: login_img }
                    ]);
            }
        }
        else{
            setItems([
                { id: 0, name: "Знакомства", img: false },
                { id: 1, name: "Настройки", img: false },
                { id: 2, name: "Мои сообщения", img: false, notice: myProfile.info.notice },
                { id: 3, name: "Мои лайки", img: false , podmenu: 
                    [
                        {id:0, name: 'Лайки', like: myProfile.info.like, func: () => OpenLike},
                        {id:1, name: 'Взаимные лайки', like: myProfile.info.likeall , func: () => OpenLove} 
                    ]
                },
                { id: 4, name: "Выйти", img: false, stoped: true, func: () => PopupOpen(1) }
            ]);
        }
        
    }, [stage,page,myProfile]); 
    
    useEffect(() => {
        if(stage !== 0 && myProfile.info.menuopen) toggleMenu();
    }, [page,stage]); 

    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
    const toggleMenu = () => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                menuopen: !prevState.info.menuopen
            }
        }));
    };
    const toggleLike = () => {
        const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getCountLike`;
        const config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };
        axios.post(url,{}, config)
            .then(response => {
                
                if(response.data.error === false)
                {
                    setMyProfile(prevState => ({
                        ...prevState, 
                        info: { 
                            ...prevState.info,
                             like: response.data.data.likeCount, 
                             likeall: response.data.data.submitLike,
                             likeopen: !prevState.info.likeopen
                             }
                    }));
                }
                else
                {
                    setMyProfile(prevState => ({
                        ...prevState, 
                        info: { 
                            ...prevState.info,
                             like: 0, 
                             likeall: 0,
                             likeopen: !prevState.info.likeopen
                             }
                    }));
                }
            })
                .catch(error => {
                    console.log(error);
                
                    
            });
        
    };
     
    const OpenLike = () => {
        const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getLike`;
        const config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };
        axios.post(url,{}, config)
            .then(response => {
                
                if(response.data.like === true)
                {
                    
                    setLike(response.data.date);
                }
                else
                {
                    setLike([]);
                    console.log(response.data);
                }
            })
                .catch(error => {
                    console.log(error);
                
                    
            });
        PopupOpen(12);
    };
    Header.OpenLike = OpenLike;
    const OpenLove = () => {
        const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getSubmitLike`;
        const config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };
        axios.post(url,{}, config)
            .then(response => {
                
                if(response.data.like === true)
                {
                    
                    setMutual(response.data.date);
                }
                else
                {
                    console.log(response.data);
                }
            })
                .catch(error => {
                    console.log(error);
                
                    
            });
        PopupOpen(13);
    };
    Header.OpenLove = OpenLove;
    Header.setPage = setPage;
    return(
        <div className={stylez.header + ' ' + (myProfile.info.menuopen ? stylez.showmenu : null)}>
            <img src={logo} className={stylez.logotype} alt="" onClick={() => (setPage(0))}/>
            {items.map(item => (
                items.length <= 1 ?
                (
                    <div key = {item.id} className={stylez.menumob  + ' ' + (item.podmenu &&  myProfile.info.likeopen ? stylez.podmenu : null) + ' ' + (item.id === page ? stylez.pageactive : null)} onClick={() => (!item.stoped ? (!item.podmenu ? setPage(item.id) :  toggleLike()) : (item.func && item.func()) ) }>
                    { item.img === true ? <img src={login_img} alt=''/>
                        : null
                        }
                        <p>{item.name}</p>
                        { item.notice ? <img src={notice} className={stylez.notice} alt=''/> : null}           
                        <div className={stylez.menuz}>
                            {item.podmenu ? item.podmenu.map(zz => (
                                <div key={zz.id} className={stylez.menushka} onClick={zz.func()}>
                                    <span className={stylez.title}>{zz.name}</span>
                                    <span className={stylez.column}>{zz.like}</span>
                                </div>
                            )):null}
                        </div>
                    </div>  
                )
                :
                (   item.id === 0 && page >= 5 ?

                     <p key={item.id} onClick={toggleMenu} className={stylez.menumob}> { myProfile.info.menuopen === true ? <img src={top_menu} alt=''/> : <img src={bottom_menu} alt=''/>} Меню</p>
                    :
                    
                    (item.id === page ? <p key={item.id} onClick={toggleMenu} className={stylez.menumob}> { myProfile.info.menuopen === true ? <img src={top_menu} alt=''/> : <img src={bottom_menu} alt=''/>} Меню</p> :null)
                )
                
            ))}
            <ul className={stylez.menu}>
            {items.map(item => (
                <li key = {item.id} className={stylez.btnImg  + ' ' + (item.podmenu &&  myProfile.info.likeopen ? stylez.podmenu : null) + ' '}  onClick={() => (!item.stoped ? (!item.podmenu ? setPage(item.id) :  toggleLike()) : (item.func && item.func()) ) }>
                   { item.img === true ? <img src={login_img} alt=''/>
                    : null
                    }
                    <p>{item.name}</p>
                    { item.notice ? <img src={notice} className={stylez.notice} alt=''/> : null}           
                    <div className={stylez.menuz}>
                        {item.podmenu ? item.podmenu.map(zz => (
                            <div key={zz.id} className={stylez.menushka} onClick={zz.func()}>
                                <span className={stylez.title}>{zz.name}</span>
                                <span className={stylez.column}>{zz.like}</span>
                            </div>
                        )):null}
                    </div>
                </li>  
              
            ))}
            </ul>
        </div>
    );
}
export default Header;